export default {
  'pages.overview.dashboard.title': '仪表盘',
  'pages.overview.dashboard.subtitle':
    '总部管理数据总览：租户统计、门店统计、设备统计',
  'pages.overview.dashboard.filter.year': '统计年份',
  'pages.overview.dashboard.action.reset': '重置',
  'pages.overview.dashboard.action.query': '查询',
  'pages.overview.dashboard.action.retry': '重新加载',
  'pages.overview.dashboard.empty': '暂无数据',
  'pages.overview.dashboard.error.region': '该区域数据加载失败',
  'pages.overview.dashboard.unit.count': '个',
  'pages.overview.dashboard.unit.device': '台',
  'pages.overview.dashboard.section.tenant': '租户统计',
  'pages.overview.dashboard.section.tenantDesc':
    '关注租户数量、订阅状态、行业结构及新增情况',
  'pages.overview.dashboard.section.store': '门店统计',
  'pages.overview.dashboard.section.storeDesc':
    '关注门店数量、门店类型、状态、税务类型及新增情况',
  'pages.overview.dashboard.section.device': '设备统计',
  'pages.overview.dashboard.section.deviceDesc':
    '支持运维快速判断在线、授权、更新与到期风险',
  'pages.overview.dashboard.card.tenantTotal': '租户总数',
  'pages.overview.dashboard.card.tenantActive': '激活租户',
  'pages.overview.dashboard.card.tenantExpiring': '即将到期租户',
  'pages.overview.dashboard.card.tenantExpired': '已过期租户',
  'pages.overview.dashboard.card.tenantNew30Days': '近30天新增租户',
  'pages.overview.dashboard.card.storeTotal': '门店总数',
  'pages.overview.dashboard.card.directStore': '直营店',
  'pages.overview.dashboard.card.experienceStore': '体验店',
  'pages.overview.dashboard.card.franchiseStore': '加盟店',
  'pages.overview.dashboard.card.storeNew30Days': '近30天新增门店',
  'pages.overview.dashboard.card.deviceTotal': '设备总数',
  'pages.overview.dashboard.card.deviceEnabled': '启用设备',
  'pages.overview.dashboard.card.deviceOnline': '在线设备',
  'pages.overview.dashboard.card.deviceExpiring': '即将到期设备',
  'pages.overview.dashboard.card.deviceNew30Days': '近30天新增设备',
  'pages.overview.dashboard.card.deviceCompliant': '合规设备',
  'pages.overview.dashboard.card.deviceNotEnabled': '未启用设备',
  'pages.overview.dashboard.card.deviceOffline': '离线设备',
  'pages.overview.dashboard.card.deviceExpired': '过期设备',
  'pages.overview.dashboard.card.deviceUpgrade': '待升级设备',
  'pages.overview.dashboard.chart.tenantMonthly': '{year}年租户新增数量',
  'pages.overview.dashboard.chart.subscription': '订阅状态分布',
  'pages.overview.dashboard.chart.industry': '行业类型分布',
  'pages.overview.dashboard.chart.storeMonthly': '{year}年门店新增数量',
  'pages.overview.dashboard.chart.storeStatus': '门店状态分布',
  'pages.overview.dashboard.chart.tax': '门店含税 / 免税',
  'pages.overview.dashboard.chart.deviceVersion': '设备版本统计',
  'pages.overview.dashboard.chart.deviceStatus': '设备状态分布',
  'pages.overview.dashboard.distribution.normalTenant': '正常租户',
  'pages.overview.dashboard.distribution.expiringTenant': '即将到期租户',
  'pages.overview.dashboard.distribution.expiredTenant': '已过期租户',
  'pages.overview.dashboard.distribution.restaurant': '餐饮',
  'pages.overview.dashboard.distribution.retail': '零售',
  'pages.overview.dashboard.distribution.fastFood': '快餐',
  'pages.overview.dashboard.distribution.unconfigured': '未配置',
  'pages.overview.dashboard.distribution.normalStore': '正常门店',
  'pages.overview.dashboard.distribution.closedStore': '停业门店',
  'pages.overview.dashboard.distribution.cancelledStore': '注销门店',
  'pages.overview.dashboard.distribution.onlineDevice': '在线设备',
  'pages.overview.dashboard.distribution.offlineDevice': '离线设备',
  'pages.overview.dashboard.distribution.notEnabledDevice': '未启用设备',
  'pages.overview.dashboard.serverMonitor.title': '服务器监控',
  'pages.overview.dashboard.serverMonitor.sectionDesc':
    'API 服务器资源使用情况',
  'pages.overview.dashboard.serverMonitor.refresh': '刷新',
  'pages.overview.dashboard.serverMonitor.refreshFailed':
    '刷新失败,已保留上次数据',
  'pages.overview.dashboard.serverMonitor.cpu': 'CPU',
  'pages.overview.dashboard.serverMonitor.cpuCores': '{n} 逻辑核心',
  'pages.overview.dashboard.serverMonitor.memory': '内存',
  'pages.overview.dashboard.serverMonitor.swap': '交换分区',
  'pages.overview.dashboard.serverMonitor.swapDisabled': '未启用',
  'pages.overview.dashboard.serverMonitor.disk': '磁盘挂载点',
  'pages.overview.dashboard.serverMonitor.diskColMount': '挂载点',
  'pages.overview.dashboard.serverMonitor.diskColUsage': '使用率',
  'pages.overview.dashboard.serverMonitor.diskColCapacity': '已用 / 总量',
  'pages.overview.dashboard.serverMonitor.dataTime': '采集于 {time}',
};
